import actions from './filtersActions'

export const initialState = {
    relatedFilters: [],
    temporalUnpinned: {},
}

export const mutations = {
    CLEAN (state) {
        Object.assign(state, initialState)
    },
    SET_RELATED_FILTERS (state, relatedFilters) {
        state.relatedFilters = relatedFilters
    },
    SET_TEMPORAL_UNPINNED (state, temporalUnpinned) {
        state.temporalUnpinned = temporalUnpinned
    },
}

export const getters = {
    relatedFilters: state => state.relatedFilters,
    temporalUnpinned: state => state.temporalUnpinned,
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions,
    getters,
    mutations,
}
